export const addToSelectionAction = {
    title: "Add to Selection",
    id: "add-selection",
    className: "esri-icon-plus-circled",
  };
  
  export const removeFromSelectionAction = {
    title: "Remove from Selection",
    id: "remove-selection",
    className: "esri-icon-minus-circled",
  };